const table2 = (editor) => {

    editor.BlockManager.add(`Table2`, {
        category: 'Tables',
        label: `
          <svg width='1.2vw' height='1.2vw' viewBox="0 -52 512.00001 512" xmlns="http://www.w3.org/2000/svg"><path d="m0 113.292969h113.292969v-113.292969h-113.292969zm30.003906-83.289063h53.289063v53.289063h-53.289063zm0 0"/><path d="m149.296875 0v113.292969h362.703125v-113.292969zm332.699219 83.292969h-302.695313v-53.289063h302.695313zm0 0"/><path d="m0 260.300781h113.292969v-113.292969h-113.292969zm30.003906-83.292969h53.289063v53.289063h-53.289063zm0 0"/><path d="m149.296875 260.300781h362.703125v-113.292969h-362.703125zm30.003906-83.292969h302.695313v53.289063h-302.695313zm0 0"/><path d="m0 407.308594h113.292969v-113.296875h-113.292969zm30.003906-83.292969h53.289063v53.289063h-53.289063zm0 0"/><path d="m149.296875 407.308594h362.703125v-113.296875h-362.703125zm30.003906-83.292969h302.695313v53.289063h-302.695313zm0 0"/></svg>
          <div class="gjs-fontFamily gjs-block-label">Table</div>
          `,
        attributes: {},
        content: `
            <div class="table-responsive">
              <table class="table table-stripped2 table-border">
                <thead class="table-dark">
                  <tr>
                    <th>
                      <span class="horiz-center-item table-line-height">Project</span>
                    </th>
                    <th>
                      <span class="horiz-center-item table-line-height">Status</span>
                    </th>
                    <th>
                      <span class="horiz-center-item table-line-height">Completed</span>
                    </th>
                    <th>
                      <span class="horiz-center-item table-line-height">Created</span>
                    </th>
                    <th>
                      <span class="horiz-center-item table-line-height">Action</span>
                    </th>
                  </tr>
                </thead>
                <tbody dataitems=getAllRows>
                  <tr dataitem=true>
                    <td >
                      <span class="horiz-center-item table-line-height">Cell</span>
                    </td>
                    <td >
                      <span class="horiz-center-item table-line-height">Cell</span>
                    </td>
                    <td >
                      <span class="horiz-center-item table-line-height">Cell</span>
                    </td>
                    <td >
                      <span class="horiz-center-item table-line-height">Cell</span>
                    </td>
                    <td class="space-around-elements">
                      <div class="btn pointer bi bi-pencil-square manage-btn">&nbsp;Manage</div>
                      <div class="btn pointer bi bi-archive archive-btn">&nbsp;Archive</div>
                      <div class="btn pointer bi bi-trash delete-btn">&nbsp;Delete</div>
                    </td>
                  </tr>
                  <tr dataitem=true>
                    <td >
                      <span class="horiz-center-item table-line-height">Cell</span>
                    </td>
                    <td >
                      <span class="horiz-center-item table-line-height">Cell</span>
                    </td>
                    <td >
                      <span class="horiz-center-item table-line-height">Cell</span>
                    </td>
                    <td >
                      <span class="horiz-center-item table-line-height">Cell</span>
                    </td>
                    <td class="space-around-elements">
                      <div class="btn pointer bi bi-pencil-square manage-btn">&nbsp;Manage</div>
                      <div class="btn pointer bi bi-archive archive-btn">&nbsp;Archive</div>
                      <div class="btn pointer bi bi-trash delete-btn">&nbsp;Delete</div>
                    </td>
                  </tr>
                  <tr dataitem=true>
                    <td >
                      <span class="horiz-center-item table-line-height">Cell</span>
                    </td>
                    <td >
                      <span class="horiz-center-item table-line-height">Cell</span>
                    </td>
                    <td >
                      <span class="horiz-center-item table-line-height">Cell</span>
                    </td>
                    <td >
                      <span class="horiz-center-item table-line-height">Cell</span>
                    </td>
                    <td class="space-around-elements">
                      <div class="btn pointer bi bi-pencil-square manage-btn">&nbsp;Manage</div>
                      <div class="btn pointer bi bi-archive archive-btn">&nbsp;Archive</div>
                      <div class="btn pointer bi bi-trash delete-btn">&nbsp;Delete</div>
                    </td>
                  </tr>
                  <tr dataitem=true>
                    <td >
                      <span class="horiz-center-item table-line-height">Cell</span>
                    </td>
                    <td >
                      <span class="horiz-center-item table-line-height">Cell</span>
                    </td>
                    <td >
                      <span class="horiz-center-item table-line-height">Cell</span>
                    </td>
                    <td >
                      <span class="horiz-center-item table-line-height">Cell</span>
                    </td>
                    <td class="space-around-elements">
                      <div class="btn pointer bi bi-pencil-square manage-btn">&nbsp;Manage</div>
                      <div class="btn pointer bi bi-archive archive-btn">&nbsp;Archive</div>
                      <div class="btn pointer bi bi-trash delete-btn">&nbsp;Delete</div>
                    </td>
                  </tr>
                  <tr dataitem=true>
                    <td >
                      <span class="horiz-center-item table-line-height">Cell</span>
                    </td>
                    <td >
                      <span class="horiz-center-item table-line-height">Cell</span>
                    </td>
                    <td >
                      <span class="horiz-center-item table-line-height">Cell</span>
                    </td>
                    <td >
                      <span class="horiz-center-item table-line-height">Cell</span>
                    </td>
                    <td class="space-around-elements">
                      <div class="btn pointer bi bi-pencil-square manage-btn">&nbsp;Manage</div>
                      <div class="btn pointer bi bi-archive archive-btn">&nbsp;Archive</div>
                      <div class="btn pointer bi bi-trash delete-btn">&nbsp;Delete</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          `
      });
}

export default table2;